<!-- components/VersionChecker.vue -->
<template>
    <div v-if="showUpdate" class="version-alert">
        <span>A new version of the site is available, please refresh.</span>
        <button @click="reload" class="btn btn-sm btn-primary ms-2">Refresh</button>
    </div>
</template>

<script setup>
    import { ref, onMounted } from 'vue';
    const showUpdate = ref(false);
    const currentVersion = ref(null);

    const checkForUpdate = async () => {
        try {
            const res = await fetch('/api/version', { cache: 'no-store' });

            // Fail fast if the server is not ready
            if (!res.ok) throw new Error(`Status ${res.status}`);

            const { version: serverVersion } = await res.json();

            if (!currentVersion.value) {
                localStorage.setItem('app_version', serverVersion);
                currentVersion.value = serverVersion;
            } else if (serverVersion && serverVersion !== currentVersion.value) {
                showUpdate.value = true;
            }
        } catch (err) {
            if (import.meta.env.DEV) {
                console.warn('[VersionCheck] Failed (dev)', err);
            } else {
                // Silent fail or log less aggressively in production
                console.info('[VersionCheck] Skipped (probably deploy in progress)', err?.message ?? err);
            }
        }
    };

    const reload = () => {
        localStorage.setItem('app_version', Date.now().toString());
        location.reload(true);
    };

    onMounted(() => {
        checkForUpdate();
        setInterval(() => {
            if (!document.hidden) checkForUpdate();
        }, 30000);
    });
</script>

<style scoped>
    .version-alert {
        position: fixed;
        bottom: 10px;
        right: 10px;
        background: #f8d7da;
        color: #721c24;
        padding: 0.75rem 1rem;
        border-radius: 8px;
        box-shadow: 0 0 10px rgba(0,0,0,0.1);
        display: flex;
        align-items: center;
        z-index: 9999;
    }
</style>
